@if (canUsePushNotifications) {
    <button
        mat-icon-button
        type="button"
        class="notification-trigger"
        [attr.aria-label]="notificationsEnabled ? 'Åbn notifikationer' : 'Notifikationer er slået fra'"
        (click)="openDialog($event)"
    >
        <mat-icon [svgIcon]="bellIcon"></mat-icon>
    </button>
}
